import * as ProfileActionCreator from "./ProfileActionCreator";

export function profileDetails() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const ProfileReducer = (state, action) => {
  if (
    !state ||
    action.type === ProfileActionCreator.PROFILE_ACTION.RESET_PROFILE_STATE
  ) {
    return { ...state, ...profileDetails() };
  }

  if (action.type === ProfileActionCreator.PROFILE_ACTION.REQUEST_PROFILE) {
    return { ...state, loading: true };
  }

  if (action.type === ProfileActionCreator.PROFILE_ACTION.PROFILE_RESPONSE) {
    return { ...state, response: action.data, loading: false };
  }

  if (action.type === ProfileActionCreator.PROFILE_ACTION.PROFILE_ERROR) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};
export function updateProfileUser() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const UpdateProfileUserReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      ProfileActionCreator.PROFILE_ACTION.RESET_UPDATE_PROFILE_FOR_USER
  ) {
    return { ...state, ...updateProfileUser() };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.REQUEST_UPDATE_PROFILE_FOR_USER
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.RESPONSE_UPDATE_PROFILE_FOR_USER
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.ERROR_UPDATE_PROFILE_FOR_USER
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function uploadProfilePicture() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const UploadProfilePictureReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      ProfileActionCreator.PROFILE_ACTION.RESET_UPLOAD_PROFILE_PICTURE
  ) {
    return { ...state, ...uploadProfilePicture() };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.REQUEST_UPLOAD_PROFILE_PICTURE
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.RESPONSE_UPLOAD_PROFILE_PICTURE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.ERROR_UPLOAD_PROFILE_PICTURE
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function defaultGetProfilePictureState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const GetProfilePictureReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      ProfileActionCreator.PROFILE_ACTION.RESET_GET_PROFILE_PICTURE
  ) {
    return { ...state, ...defaultGetProfilePictureState() };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.REQUEST_GET_PROFILE_PICTURE
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.RESPONSE_GET_PROFILE_PICTURE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.ERROR_GET_PROFILE_PICTURE
  ) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};
export function defaultUploadCoverImageState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const UploadCoverImageReducer = (state, action) => {
  if (
    !state ||
    action.type === ProfileActionCreator.PROFILE_ACTION.RESET_UPLOAD_COVER_IMAGE
  ) {
    return { ...state, ...defaultUploadCoverImageState() };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.REQUEST_UPLOAD_COVER_IMAGE
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type ===
    ProfileActionCreator.PROFILE_ACTION.RESPONSE_UPLOAD_COVER_IMAGE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type === ProfileActionCreator.PROFILE_ACTION.ERROR_UPLOAD_COVER_IMAGE
  ) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};

export function defaultGetCoverImageState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const GetCoverImageReducer = (state, action) => {
  if (
    !state ||
    action.type === ProfileActionCreator.PROFILE_ACTION.RESET_GET_COVER_IMAGE
  ) {
    return { ...state, ...defaultGetCoverImageState() };
  }
  if (
    action.type === ProfileActionCreator.PROFILE_ACTION.REQUEST_GET_COVER_IMAGE
  ) {
    return { ...state, loading: true };
  }
  if (
    action.type === ProfileActionCreator.PROFILE_ACTION.RESPONSE_GET_COVER_IMAGE
  ) {
    return { ...state, response: action.data, loading: false };
  }
  if (
    action.type === ProfileActionCreator.PROFILE_ACTION.ERROR_GET_COVER_IMAGE
  ) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};
